import { render, staticRenderFns } from "./YouzhicaiCategory.vue?vue&type=template&id=2e11dddc&scoped=true"
import script from "./YouzhicaiCategory.vue?vue&type=script&lang=js"
export * from "./YouzhicaiCategory.vue?vue&type=script&lang=js"
import style0 from "./YouzhicaiCategory.vue?vue&type=style&index=0&id=2e11dddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e11dddc",
  null
  
)

export default component.exports